import type { QueryClient } from "@tanstack/react-query";
import { redirect } from "@tanstack/react-router";

import { ApiError } from "~/lib/api";
import { meQueryOptions, type Partner } from "~/lib/api/me";
import { auth, authReady, signOut } from "~/lib/auth";

export async function endSession(queryClient: QueryClient): Promise<void> {
  await signOut();
  queryClient.clear();
}

export async function requirePartner(queryClient: QueryClient): Promise<Partner> {
  await authReady();
  if (!auth.currentUser) throw redirect({ to: "/inloggen" });

  try {
    return await queryClient.query(meQueryOptions());
  } catch (error) {
    if (error instanceof ApiError && (error.status === 401 || error.status === 403)) {
      await endSession(queryClient);
      throw redirect({
        to: "/inloggen",
        search: { melding: error.status === 401 ? "verlopen" : "geen-account" },
      });
    }
    throw error;
  }
}
